import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeKnowledgeCapabilitiesResponseDataSchema,
  DataResponse,
  GetBackofficeKnowledgeItemsSchema,
} from "schema"
import { z } from "zod"

type Query = Omit<z.input<typeof GetBackofficeKnowledgeItemsSchema>, "companyId"> & {
  companyId: string | undefined
}
type Response = DataResponse<z.infer<typeof BackofficeKnowledgeCapabilitiesResponseDataSchema>>

export const getBackofficeKnowledgeCapabilitiesQuery = ({ query }: { query: Query }) => {
  return queryOptions({
    placeholderData: () => undefined,
    queryKey: ["backofficeKnowledgeCapabilities", query],
    enabled: Boolean(query.companyId),
    queryFn: async ({ signal }) => {
      const { data } = await axios.get<Response>("/backoffice/knowledge/capabilities", {
        params: query,
        signal,
      })
      return data.data
    },
  })
}
